import { SearchFeedbackPost, Controllers } from "@infoland/iprova-api";

// state type

// getters for this store
const getters = {};

// mutations for this store
const mutations = {};

// actions for this store
const actions = {
    async createSearchFeedbackAsync({ commit }, searchFeedbackModel: SearchFeedbackPost): Promise<void | null> {
        return await Controllers.SearchFeebackController.createSearchFeedbackAsync(searchFeedbackModel);
    }
};

// export namespace
export const namespace = "searchFeedback";
// export the store 'module'
export default {
    namespaced: true,
    getters,
    mutations,
    actions
};
